import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6295 7.65717L6.02093 10.9163l5.39017 1.6755 1.6755 5.3902 3.2591-4.6086 5.6441.0721-3.3758-4.52372 1.8127-5.34556-5.3456 1.81273-4.5237-3.37588.0721 5.6441zm-.0139 5.73373l-1.08579-.332-7.52995 7.5299 1.41421 1.4143 7.53183-7.5319-.3303-1.0803z",
    fill: "currentColor"
  }));
});